import marquee from "vanilla-marquee";

class BlockTicker {
    constructor(blockEl) {
        this.blockEl = blockEl;
        this.marquee = document.getElementById('marquee');

        this.initializeMarquee();
    }

    initializeMarquee() {
        new marquee(document.getElementById('marquee'), {
            css3easing: 'linear',
            duplicated: true,
            speed: 80,
            startVisible: true,
        });
    }

}

export default BlockTicker;